import React from "react";
// SCSS
import "./teamInfo.scss";
import { FaTv } from "react-icons/fa"; // TV icon

const TVMedia = () => (
<div className="team__info flex-center" >
<div style={{ textAlign: "center" }}>
      <FaTv size={40} style={{ marginBottom: "10px", color: "#333" }} />
      <h4 className="font20 weight800">TV & Media</h4>
      <br></br>
      <p className="font12 weight500" style={{ marginBottom: "40px", color: "#333" }}>
      We make sure to follow and ensure TV media buying to make your brand visible in the most important games
      </p>
    </div>
  </div>
);

export default TVMedia;
